import { Skeleton as UiSkeleton } from '@/components/ui/skeleton'
import { cn } from '@/lib/utils'

import { skeletonVariants } from '../../configs/skeleton.config'

import type { ComponentProps } from 'react'

export function Skeleton({ className, ...props }: ComponentProps<typeof UiSkeleton>) {
  return <UiSkeleton {...props} className={cn(skeletonVariants(), className)} />
}
